import React from 'react';
import { MarketingImage } from 'components/MarketingPagesShared/MarketingImage';
import { MarketingBoldLink } from 'components/MarketingPagesShared/styles';
import { useT } from 'i18n/hooks/useT';
import { HomeSectionTitle } from '../../../styles';
import { HomeSectionWithBackground } from '../../HomeSectionWithBackground';

export function HomeShare({ onClickCTA }: { onClickCTA?: () => void }) {
  const t = useT();
  return (
    <HomeSectionWithBackground
      backgroundImagePath="bg-share.svg"
      textColumn={
        <>
          <HomeSectionTitle
            dangerouslySetInnerHTML={{
              __html: t(
                'HomePage.HomeShare.Title',
                '<strong>Distribute your podcast to the most popular listening apps, including Spotify with just a single tap</strong> — and host unlimited content completely free, forever.',
                'Anchor home page distribution features section title'
              ),
            }}
          />
          <MarketingBoldLink to="/features#hosting" onClick={onClickCTA}>
            {t(
              'HomePage.HomeShare.DistributionFeaturesLinkText',
              'See all hosting and distribution features',
              'Anchor home page distribution features link text'
            )}
          </MarketingBoldLink>
        </>
      }
      imageColumn={
        <MarketingImage
          width={520}
          height={520}
          imagePath="home/hosting/host"
          alt={t(
            'HomePage.HomeShare.DistributionImageAlt',
            'A picture of two women smiling in front of a laptop',
            'Anchor home page distribution image screenreader information'
          )}
        />
      }
    />
  );
}
